import { ComponentIds, ConnectionUtils, ReplaceUtils } from '@inter-ikea-core/core';
export const productReplacementMap = {
    '80333284': '30512283',
    '30333842': '00512289',
    '40382785': '90512280',
    '90333288': '10512279'
};
const isProductInMarket = (productRef, products) => {
    return products.some(product => product.coreProductId === productRef);
};
export const checkAndReplaceEntities = (coreApi, products) => {
    const entities = coreApi.core.services.sceneManager.entities;
    if (!entities)
        return;
    for (const [singleProductRef, fourPackProductRef] of Object.entries(productReplacementMap)) {
        if (!isProductInMarket(singleProductRef, products))
            continue;
        const matchingFourPackEntites = entities.filter(e => {
            const productComponent = e.getComponent(ComponentIds.PRODUCT_COMPONENT_ID);
            return productComponent?.productRef === fourPackProductRef;
        });
        if (matchingFourPackEntites.length % 4 !== 0) {
            replaceEntities(coreApi.core, coreApi.placementService, matchingFourPackEntites, singleProductRef, matchingFourPackEntites.length % 4);
        }
    }
    for (const [singleProductRef, fourPackProductRef] of Object.entries(productReplacementMap)) {
        if (!isProductInMarket(fourPackProductRef, products))
            continue;
        const matchingSingleEntites = entities.filter(e => {
            const productComponent = e.getComponent(ComponentIds.PRODUCT_COMPONENT_ID);
            return productComponent?.productRef === singleProductRef;
        });
        if (matchingSingleEntites.length % 4 === 0) {
            replaceEntities(coreApi.core, coreApi.placementService, matchingSingleEntites, fourPackProductRef, matchingSingleEntites.length);
        }
        else {
            replaceEntities(coreApi.core, coreApi.placementService, matchingSingleEntites, fourPackProductRef, Math.floor(matchingSingleEntites.length / 4) * 4);
        }
    }
};
const replaceEntities = (core, placementService, entities, newProductRef, count) => {
    const productManager = core.services.productManager;
    for (let i = 0; i < count; i++) {
        const newEntity = productManager.createEntity(newProductRef);
        if (newEntity) {
            const oldEntity = entities[i];
            ReplaceUtils.replaceEntity(oldEntity, newEntity, 0, core.services);
            if (core.services.entityManager.findEntity(oldEntity.id)) {
                ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(oldEntity);
            }
        }
    }
};
//# sourceMappingURL=ShelfSystemUtils.js.map